module.exports = __webpack_public_path__ + "img/overuse.6d93f1bd.png";